import type { ReactNode } from 'react'
import { Boxes } from 'lucide-react'
import { EmptyState } from '@comforthub/design-system'
import { useAuth } from '../contexts/AuthContext'
import { anyModuleEnabled, moduleEnabled } from '../lib/modules'
import { MODULE_NOT_IN_PACKAGE } from '../lib/apiError'

interface RequireModuleProps {
  /** The package module the page belongs to (`bookings`, `shifts`, …). */
  module?: string
  /** A page that serves several modules shows when any one is on (Rewards: `promo_codes` or `loyalty`). */
  anyModule?: string[]
  children: ReactNode
}

/**
 * A page of a package module the company doesn't have says so, instead of loading
 * and failing on every request. The menu already hides it; this is for a link or a
 * bookmark. /api/me without `modules` (an older core) counts as every module on.
 */
export default function RequireModule({ module, anyModule, children }: RequireModuleProps) {
  const { modules, loading } = useAuth()
  if (loading) return null
  const on = (module == null || moduleEnabled(modules, module))
    && (!anyModule?.length || anyModuleEnabled(modules, anyModule))
  if (on) return <>{children}</>
  return (
    <div className="p-6">
      <EmptyState
        icon={<Boxes size={18} />}
        title={MODULE_NOT_IN_PACKAGE}
        text="This part of ComfortHub isn't in your company's package. Business › Package shows what is."
      />
    </div>
  )
}
